import LabelMap from '../../../bootstrap/types/label-map/LabelMap';
import __ from '../../i18n';

const VISIBILITY_PUBLIC = 'PUBLIC';
const VISIBILITY_PRIVATE = 'PRIVATE';
const VISIBILITY_ARCHIVED = 'ARCHIVED';

const visibilities = new LabelMap([
    [VISIBILITY_PUBLIC, __('Public')],
    [VISIBILITY_PRIVATE, __('Private')],
    [VISIBILITY_ARCHIVED, __('Archived')],
]);

export default visibilities;

export {
    VISIBILITY_PUBLIC,
    VISIBILITY_PRIVATE,
    VISIBILITY_ARCHIVED,
}
